import { render, staticRenderFns } from "./StrategyReportTable.vue?vue&type=template&id=68794308&scoped=true&"
import script from "./StrategyReportTable.vue?vue&type=script&lang=js&"
export * from "./StrategyReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68794308",
  null
  
)

export default component.exports